<template>
    <div class="zhuanyexiangqing">
        <div class="header">
            <div class="inner">
                <div class="top_title">
                    <div class="imgBox"></div>
                    <div class="main">
                        <p class="title">{{detailData.majorName}}</p>
                        <p class="detail">
                            <span>专业代码： {{detailData.majorCode}}</span><br/>
                            <span>学历层次： {{detailData.majorType}}</span>
                            <span>授予学位： {{detailData.majorName}}学位</span>                           
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab">
           <span v-for="item,index in tabList" :class="index == active?'active':''" @click="tabChange(index)">{{item.name}}</span>
        </div>
        <!-- 专业 -->
        <div class="inner" v-show="active==0">
            <div class="benke">
                <div class="content">
                    <!-- 培养目标 -->
                    <div class="neirongBox">
                        <p class="title">专业介绍</p>
                        <p class="xiangqing" v-html="detailData.majorContent"></p>
                    </div>
                    <!-- 主要课程 -->
                    <div class="neirongBox">
                        <p class="title">主要课程</p>
                        <p class="xiangqing" v-html="detailData.courses"></p>
                    </div>
                    <!-- 学习门槛 -->
                    <div class="neirongBox">
                        <p class="title">学习门槛</p>
                        <div class="xiangqing" v-html="detailData.studyDifficulty"></div>
                    </div>
                    <!-- 考研方向 -->
                    <div class="neirongBox">
                        <p class="title">考研方向</p>
                        <p class="xiangqing" v-html="detailData.postgraduateDirection">
                        </p>
                    </div>
                    <!-- 相近专业 -->
                    <div class="neirongBox">
                        <p class="title">相近专业</p>
                        <p class="xiangqing">
                            <span v-for="(item, index) in detailData.similarMajor"> {{item}} </span>
                        </p>
                    </div>
                    <!-- 就业方向 -->
                    <div class="neirongBox">
                        <p class="title">就业方向</p>
                        <p class="xiangqing" v-html="detailData.employmentDirection">
                        </p>
                    </div>
                </div>
            </div>
        </div> 
        <!-- 专业 -->
        <div class="inner" v-show="active==1">
            <div v-for="item,index in schoolData" class="list-box">
                <img :src="item.collegeImage">
                <div>
                    <span @click="go(item.collegeID)">{{item.collegeName}}</span>
                    <p>
                        <span><img src="/imgs/explore/zhiyeku/part-01.png"/>{{item.universityMembership}}</span>
                        <span><img src="/imgs/explore/zhiyeku/part-02.png"/>{{item.province}}</span>
                    </p>
                </div>
            
            </div>
        </div>
    </div>
</template>
<style type="text/css" lang='less' scoped>
    .zhuanyexiangqing {
        margin-left: 20px;
        background: #fff;
        // padding-bottom: 20px;
        .inner {
            width: 930px;
            margin: 0 auto;
        }
        // 小导航，用于返回上一页
        .mianbaoxie {
            height: 40px;
            font-size: 12px;
            line-height: 40px;
            color: #fff;
            position: relative;
            .no1 {
                padding-left: 5px;
                cursor: pointer;
                &:hover {
                    color: #2d90f8;
                }
            }
            .no2 {
                padding-left: 10px;
                cursor: pointer;
                &:hover {
                    color: #2d90f8;
                }
            }
            .no3 {
                padding-left: 10px;
                color: #2d90f8;
            }
            .goBack {
                position: absolute;
                width: 50px;
                height: 26px;
                line-height: 26px;
                background-color: #2d90f8;
                color: #fff;
                right: 0;
                top: 3px;
                border-radius: 2px;
                text-align: center;
                cursor: pointer;
            }
        }
        .header {
            height: 140px;
            color: #333;
            background: url(/imgs/explore/zhiyeku/bg_xiangqing.png) no-repeat center center;
            // margin-bottom: 20px;
            .inner {
                height: 140px;
                position: relative;
            }
            .top_title {
                padding-top: 40px;
                display: flex;
                align-items:center;
                .imgBox {
                    width: 56px;
                    height: 56px;
                    float: left;
                    border: 2px solid #fff;
                    background: url(/imgs/explore/zhiyeku/icon_gongjuxiang.png) no-repeat center center;
                    margin-left: 10px;
                }
                .main {
                    float: left;
                    padding-left: 20px;
                    color: #fff;
                    .title {
                        font-size: 22px;
                        line-height: 24px;
                        margin-bottom: 10px;
                    }
                    .detail {
                        font-size: 14px;
                        line-height: 20px;
                        span {
                            margin-right: 25px;
                        }
                    }
                }
                .collect {
                    width: 50px;
                    height: 50px;
                    position: absolute;
                    right: 0;
                    top: 50%;
                    margin-top: -25px;
                    cursor: pointer;
                    span {
                        display: block;
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }

        .benke {
            .content {
                padding-bottom: 30px;
                background-color: #fff;
                padding: 0 10px;
                .neirongBox {
                    .title {
                        font-size: 20px;
                        color: #333;
                        // height: 54px;
                        // line-height: 54px;
                        font-weight: 600;
                        border-bottom: 1px solid #dedede;
                        // padding-left: 20px;
                        position: relative;
                        padding: 13px 0px 13px 20px;
                        &:before {
                            content: '';
                            position: absolute;
                            width: 6px;
                            height: 6px;
                            border-radius: 50%;
                            background-color: #333;
                            left: 0;
                            top: 24px;
                        }
                    }
                    .xiangqing {
                        font-size: 14px;
                        color: #666666;
                        line-height: 24px;
                        padding-top: 32px;
                        padding-bottom: 26px;
                        white-space:pre-wrap;
                        span {
                            margin-right: 10px;
                            display: inline-block;
                            background-color: rgba(66,132,211,.2);
                            padding: 5px 30px;
                            border-radius: 20px;
                            margin-bottom:10px;

                            // &:hover {
                            //     cursor: pointer;
                            //     color: #3492f9;
                            // }
                        }
                    }
                }
                .yuanxiaopaiming {
                    .table_title ul {
                        width: 930px;
                        display: flex;
                        border-right: 1px solid #000;
                        li {
                            box-sizing: border-box;
                            flex: 1;
                            text-align: center;
                            height: 50px;
                            line-height: 50px;
                            font-size: 17px;
                            font-weight: 600;
                            color: #333;
                            background-color: #f5f5f5;
                            border-top: 1px solid #000;
                            border-left: 1px solid #000;
                        }
                    }
                    .table_box {
                        width: 955px;
                        height: 358px;
                        overflow-y: auto;
                    }
                    table {
                        width: 930px;
                        tr {
                            height: 50px;
                            &:hover {
                                background-color: #f5f5f5;
                            }
                            td {
                                &:first-child {
                                    cursor: pointer;
                                }
                                text-align: center;
                                height: 50px;
                                width: 25%;
                                font-size: 15px;
                            }
                        }
                    }

                    span {
                        // width: 1000px !important;
                    }
                }
            }
        }
        .zhuanke {
            .benke .content;
            min-height: 700px;
        }
        .loading {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(255,255,255,.6);
        }
    }
</style>
<style type="text/css">
    .has-gutter {
        font-size: 20px;
        color: #333 !important;
    }
</style>
<style type="text/css" lang='less' scoped>
.tab{
    display: flex;   
    text-align: center;
    justify-content: center;
    align-items: center;
    justify-items: center;
    font-size: 22px;
    font-weight: 500;
    border-bottom:1px solid #dedede;
    box-sizing:border-box;
    height:100%;
    height:80px;
    > span{
        margin:0 30px;
        // padding:20px 0;
        cursor:pointer;
        box-sizing:border-box;
        height:100%;
        line-height:80px;
    }
    > span.active{
        border-bottom:3px solid #ffa63c;
        color:#ffa63c;
        box-sizing:border-box;
    }
}
.list-box{
    display:flex;
    // justify-items:center;
    // justify-content:center;
    align-items:center;
    padding:20px 0;
    border-bottom:1px solid #dedede;
    color:#666;
    width:100%;
    > img{
        width:100px;height:100px;
        // border:1px solid #dedede;
        margin-right:20px;
    }
    > div{
       flex:1;
        > span{
            font-size:16px;
            font-weight:bold;
            cursor:pointer;
        }
        > p {
            font-size:14px;
            display:flex;           
            > span{
                display:flex;
                align-items: center;
                margin-right:28px;
                padding-top:10px;
                
            }
            span > img{
                width:18px;height:18px;
                vertical-align: bottom;
                margin-right:6px;
            }
        }
    }
}
</style>


<script>
// import Loading from '../../../.././components/Loading.vue'
export default {
    props: [ 'message' ],
    // components: { Loading },
    data() {
        return {
            detailData:[],
            schoolData:[],
            tabList:[{name:'专业简介',id:0},{name:'开设院校',id:1}],
            active:0,
        }
    },
    methods: {
        // 获取详情数据
        getDetail(){
            var _this = this;
            var token = window.sessionStorage.getItem('ymtxToken');
            var id = this.$route.query.id;
            this.$ajax
                .post( this.G_uri + '/major/detail', {
                    id: id
                },{
                    headers:{
                        token: token
                    }
                })
                // 监听数据返回
                .then(function(res) {
                    if(res.data.code == 2000) {
                        
                        let data = res.data.data;
                        _this.detailData = data;
                        _this.getSchool();
                    }else if(res.data.code == 1016) {
                        _this.$router.push('/login')
                    }

                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        //获取相关学校
        getSchool(){
            var _this = this;
            var token = window.sessionStorage.getItem('ymtxToken');
            var id = this.$route.query.id;
            this.$ajax
                .post( this.G_uri + '/major/collegeMajor', {
                    majorID: id
                },{
                    headers:{
                        token: token
                    }
                })
                // 监听数据返回
                .then(function(res) {
                    if(res.data.code == 2000) {
                        let data = res.data.data;
                        _this.schoolData = data;

                    }else if(res.data.code == 1016) {
                        _this.$router.push('/login')
                    }

                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        // 切换tab
        tabChange(index){
            let _this = this;
            _this.active = index;
        },
        // 大学详情
        go(id) {
            var id = id;
            let {href}=this.$router.resolve({
                path: '/explore/yuanxiaoxiangqing',
                name: '院校详情',
                query: {
                    id: id,
                }
            })
            // window.open(href, '_blank');   
            this.$router.push('/explore/yuanxiaoxiangqing?id='+id);
        },
    },
    activated(){
        var _this = this;
        _this.getDetail()  
    }

}
</script>
